const PushNotificationType = {
	AGREEMENT: 'Agreement',
	APP: 'AppCallback',
	ASSIGNED: 'Assigned',
	ESIGN: 'Esign',
	EXPORT: 'Export',
	FILE: 'File',
	IMPORT: 'Import',
	JOB: 'Job',
	LEAD: 'Lead',
	LISTVIEW: 'ListView',
	MAIL: 'Mail',
	MARKETING: 'MarketingCustom',
	ORDER: 'Order',
	REPORTVIEW: 'ReportView',
	SUBMIT: 'Submit',
	SYSTEM: 'System',
	VISIT: 'Visit',
	PROVISIONING: 'Provisioning',
	TICKET: 'Ticket',
	DEFAULT: 'Default'
} as const;

export type PushNotificationTypeValue = (typeof PushNotificationType)[keyof typeof PushNotificationType];

export default PushNotificationType;
